const blogs = [
  // Tips & Tricks
  {
    id: 1,
    title: "Essential Cooking Tips for Beginners",
    category: "Tips & Tricks",
    date: "March 10, 2025",
    image: "/images/blogs/TipsTricks_Recipe.jpg",
    points: [
      "Always read the recipe before starting.",
      "Preheat the oven before baking.",
      "Use fresh ingredients for better flavor.",
      "Keep knives sharp for easy cutting.",
      "Clean as you cook to stay organized.",
      "Measure ingredients accurately for best results.",
      "Use a thermometer for perfect meat cooking.",
      "Don’t overcrowd the pan while frying or sautéing.",
      "Let cooked meat rest before slicing.",
      "Experiment with seasonings but in moderation.",
    ],
  },
  {
    id: 2,
    title: "How to Make Your Food Taste Better Instantly",
    category: "Tips & Tricks",
    date: "March 15, 2025",
    image: "/images/blogs/TipsTricks_TakingTaste.jpg",
    points: [
      "Use fresh herbs for better aroma and taste.",
      "Add a pinch of salt while boiling pasta to enhance flavor.",
      "Balance acidity and sweetness for better taste.",
      "Cook spices in oil before adding them to dishes.",
      "Let meat marinate for at least an hour for deeper flavor.",
      "Deglaze your pan to capture all flavors.",
      "Use homemade stocks instead of water for soups.",
      "Roast nuts and spices before using them.",
      "Add a squeeze of lemon juice to enhance flavors.",
      "Taste as you cook and adjust seasonings accordingly.",
    ],
  },

  // Healthy
  {
    id: 3,
    title: "Healthy Eating: Best Superfoods to Include in Your Diet",
    category: "Healthy",
    date: "March 5, 2025",
    image: "/images/blogs/Healthy_FreshVegetables.jpg",
    points: [
      "Eat more leafy greens like spinach and kale.",
      "Include nuts and seeds for healthy fats.",
      "Drink plenty of water throughout the day.",
      "Choose whole grains over refined grains.",
      "Reduce sugar intake for better health.",
      "Consume probiotic-rich foods like yogurt and kefir.",
      "Eat fiber-rich foods for better digestion.",
      "Add berries for antioxidants and vitamins.",
      "Limit processed foods and opt for natural sources.",
      "Balance your meals with protein, carbs, and fats.",
    ],
  },
  {
    id: 4,
    title: "10 Easy Ways to Maintain a Balanced Diet",
    category: "Healthy",
    date: "March 12, 2025",
    image: "/images/blogs/Healthy_BalanceDiet.jpg",
    points: [
      "Start your day with a nutritious breakfast.",
      "Eat more home-cooked meals instead of processed foods.",
      "Incorporate a variety of colors in your meals.",
      "Control portion sizes to prevent overeating.",
      "Reduce your intake of sugar and artificial sweeteners.",
      "Drink plenty of water throughout the day.",
      "Choose lean proteins like fish, tofu, or beans.",
      "Limit sodium intake to avoid high blood pressure.",
      "Snack on healthy options like fruits and nuts.",
      "Practice mindful eating to enjoy your food.",
    ],
  },

  // Recipes
  {
    id: 5,
    title: "The Secret to a Perfect Paneer Tikka",
    category: "Recipes",
    date: "February 28, 2025",
    image: "/images/blogs/Recipes_PaneerTikaa.jpg",
    points: [
      "Use fresh paneer for the best texture.",
      "Marinate for at least 2 hours for deep flavor.",
      "Use a grill or tandoor for smoky taste.",
      "Brush with butter while cooking for extra richness.",
      "Serve hot with mint chutney and onion rings.",
      "Use hung curd in the marinade for better consistency.",
      "Add mustard oil to enhance flavor.",
      "Skewer paneer with veggies for variety.",
      "Cook on medium heat to avoid burning.",
      "Squeeze lemon juice before serving for a fresh taste.",
    ],
  },
  {
    id: 6,
    title: "Classic Homemade Pizza Recipe",
    category: "Recipes",
    date: "March 1, 2025",
    image: "/images/blogs/Recipes_Pizza.jpg",
    points: [
      "Use high-quality flour for a better pizza base.",
      "Let the dough rest for at least an hour before rolling.",
      "Preheat the oven at the highest temperature for a crispy crust.",
      "Use fresh mozzarella for the best texture.",
      "Spread the sauce evenly but avoid overloading it.",
      "Layer toppings evenly for consistent flavor in every bite.",
      "Use a pizza stone for a restaurant-style crust.",
      "Drizzle olive oil on top before baking for extra flavor.",
      "Bake until the cheese is bubbling and golden brown.",
      "Let the pizza rest for a few minutes before slicing.",
    ],
  },

  // Chef Stories
  {
    id: 7,
    title: "Behind the Scenes: A Day in the Life of a Chef",
    category: "Chef Stories",
    date: "February 20, 2025",
    image: "/images/blogs/ChefStory_ADayInLife.jpg",
    points: [
      "Early morning starts with market visits for fresh ingredients.",
      "Prepping ingredients is the most time-consuming task.",
      "Chefs constantly taste and adjust flavors.",
      "Team coordination is key for a smooth service.",
      "Passion and patience are essential for success.",
      "Plating and presentation matter as much as taste.",
      "Cleaning up is an integral part of kitchen work.",
      "Chefs handle high-stress situations during service hours.",
      "New recipes are tested and refined regularly.",
      "Customer feedback helps improve the final dish.",
    ],
  },
  {
    id: 8,
    title: "How a Chef Handles Pressure in a Busy Kitchen",
    category: "Chef Stories",
    date: "March 8, 2025",
    image: "/images/blogs/ChefStory_BusyDay.jpg",
    points: [
      "Stay calm and focused, even during peak hours.",
      "Prioritize tasks to manage workload effectively.",
      "Communicate clearly with the team to avoid mistakes.",
      "Always have a backup plan for unexpected situations.",
      "Keep a well-organized workstation for efficiency.",
      "Taste everything before sending out dishes.",
      "Take quick breaks to avoid burnout.",
      "Stay updated with the latest culinary techniques.",
      "Maintain hygiene and cleanliness in the kitchen.",
      "Passion and resilience are the keys to success.",
    ],
  },
];

export default blogs;
